// Light haptic feedback for touch interactions.
//
// Backed by the Vibration API (`navigator.vibrate`). This is a no-op on:
//   - desktop (no vibration hardware - the call is silently ignored)
//   - iOS Safari (Apple has never implemented the Vibration API)
// so callers don't need to feature-detect; just call it.

function vibrate(pattern: number | number[]): void {
  if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") return;
  try {
    navigator.vibrate(pattern);
  } catch {
    // Some engines throw if called outside a user gesture or when vibration is
    // disabled at the OS level. Treat any failure as "no haptics available".
  }
}

export const haptic = {
  /** A short, light tick - nav taps, toggles, minor controls. */
  tap: () => vibrate(10),
  /** A firmer two-stage pulse - confirming a deliberate action (e.g. issuing a challenge). */
  confirm: () => vibrate([18, 50, 30]),
  /** An almost-imperceptible blip - crossing a horizontal scroll-snap boundary (picker-wheel feel). */
  scrollTick: () => vibrate(5),
};
